exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RecentWork-module__column___19NZN{display:grid;gap:20px;grid-row:span 3;grid-template-rows:subgrid;grid-template-columns:subgrid}.RecentWork-module__column___19NZN strong{display:block}.RecentWork-module__column___19NZN .RecentWork-module__cards___3g9Ev,.RecentWork-module__column___19NZN .RecentWork-module__no-evidence___2-dOJ{display:grid;gap:1rem}.RecentWork-module__column___19NZN .RecentWork-module__cards___3g9Ev .RecentWork-module__project___2GWwi{display:grid}", ""]);

// exports
exports.locals = {
	"column": "RecentWork-module__column___19NZN",
	"cards": "RecentWork-module__cards___3g9Ev",
	"no-evidence": "RecentWork-module__no-evidence___2-dOJ",
	"project": "RecentWork-module__project___2GWwi"
};